module.exports = __webpack_public_path__ + "b3601dd4b13448ff9f21b7f30cd7d383.pdf";